import { useInboxQuery } from "../../Hooks";
import { parseDateToString } from "../../common/utilities/parser";
import { DownloadIcon } from "../../Icons/DownloadIcon";
import { BootstrapSpinner } from "../../common/spinners/bootstrapSpinner";
import { useMunicipality } from "../../Contexts/MunicipalityKey";
import { useInboxConfig } from "../../common/config/configHooks";

const InboxPage = () => {
  const municipality = useMunicipality()
  const inboxService = useInboxConfig();

  const { data: inboxItems, isPending: isFetchingInboxItems } =
    useInboxQuery(municipality.name);

  return (
    <>
      <div className="container inbox-container">
        <h1>Post fra kommunen</h1>
        {inboxService?.hideService ? (
          "Tjenesten er dessverre ikke tilgjenglig."
        ) : (
          <>
            {inboxService?.alertText &&
              inboxService?.alertText !== "" && (
                <div className="infoBoxLanding">
                  <p>{inboxService?.alertText}</p>
                </div>
              )}
            <p>{inboxService?.ingressText}</p>

            {isFetchingInboxItems ? (
              <BootstrapSpinner />
            ) : (
              <>
                {!!!inboxItems || inboxItems.treff.length === 0 ? (
                  <div className="no-inbox-item">
                    {inboxService?.notFoundText}
                  </div>
                ) : (
                  inboxItems?.treff.map((item, index) => {
                    return (
                      <div className="inbox-item" key={index}>
                        <div>
                          <h2>{item.meldingMetadata.tittel}</h2>

                          <p>
                            Fra {item.meldingMetadata.avsender},{" "}
                            {parseDateToString(
                              new Date(item.meldingMetadata.sendtDato)
                            )}
                          </p>

                          <div>
                            {item.meldingMetadata.dokumenter.map(
                              (document, docIndex) => {
                                return (
                                  <div key={docIndex}>
                                    <a
                                      href={document.nedlastingLenke}
                                      title={`Last ned ${document.tittel}`}
                                    >
                                      {document.tittel +
                                        " " +
                                        `(${document.size / 1000} kB)`}
                                    </a>{" "}
                                    <DownloadIcon fillColor="currentColor"/>
                                    <br />
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};
export default InboxPage;
